<template>
    <div style="width: 100%;">
        <v-chart :options="options"/>
    </div>
</template>
<style>
.echarts {
  width: 300px;
  height: 300px;
}
</style>
<script>
import ECharts from 'vue-echarts'
import 'echarts/theme/dark'
import 'echarts/lib/chart/pie'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/title'

export default {
    name : "cmpgraficopie",
    components: {
        'v-chart': ECharts
    },
    props:[		
        'titulo',
        'subtitulo',
        'rotulo',
        'legendas',
		'dados',
		'visualizarlegenda',
		'posicaolabel'
    ],
    data () {
        return {
            options : {
					title: {
						text: '',
						subtext: '',
						left: 'center',
						textStyle: {
							fontSize: 12
						},
						subtextStyle: {
							fontSize: 8
						}
					},
					color: [
						'#6610f2',  // Indigo
						'#593196',  // Purple
						'#8a5ff2',  // Indigo mais claro
						'#4c0a9c',  // Indigo mais escuro
						'#7a53b3',  // Purple mais claro
						'#4e318a',  // Purple mais escuro
						'#f26135',  // Laranja
						'#40c057',  // Verde
						'#ffc107',  // Amarelo
						'#333333',  // Cinza escuro
						'#cccccc'   // Cinza claro
					],
					tooltip: {
						trigger: 'item',
						formatter: '{a} <br/>{b} : {c} ({d}%)'
					},
					legend: {
						show: true,
						orient: 'vertical',
						left: 'left',
						top: '20',
						data: [],
						textStyle: {
							fontSize: 8
						}
					},
					series: [
						{
							name: '',
							type: 'pie',
							radius: '55%',
							center: ['50%', '50%'],
							avoidLabelOverlap: true,
							data: [],				
							emphasis: {					
								itemStyle: {
									shadowBlur: 10,
									shadowOffsetX: 0,
									shadowColor: 'rgba(0, 0, 0, 0.5)'
								}
							},
							label : {
								fontSize: 8,
								position: 'outside',
								alignTo: 'edge',
								margin: 20								
							}         
						}
					]                
            }
        }
    },
    mounted: function () {         
    },    
    computed:{
    },
    watch:{
        legendas(){
            this.options.title.text     			= this.titulo;
            this.options.title.subtext  			= this.subtitulo;
            this.options.legend.data    			= this.legendas;
            this.options.series[0].name 			= this.rotulo;
			this.options.series[0].data 			= this.dados; 
			this.options.series[0].label.position 	= this.posicaolabel; 
			this.options.legend.show				= this.visualizarlegenda 			
        }
    }    
}
</script>